export const findResource = (permissions, resourceName) =>
	permissions.find((resource) => resource.resource_name === resourceName);

export const findSubresource = (resource, subresourceName) =>
	resource?.sub_resources?.find(
		(subresource) => subresource.sub_resource_name === subresourceName,
	) || null;

export const findProvider = (resource, providerName) =>
	resource?.providers?.find((provider) => provider.display_name === providerName) || null;

export const hasAuthorizedPermission = (permissions, permissionName) =>
	permissions.some((permission) => permission.name === permissionName && permission.authorized);
